import type { UseListResult } from '@ztechapps/common.hook'
import type { BlogCategoryRecord } from './types'
import { useList } from '@ztechapps/common.hook'
import { blogCategoryQueries } from './graphql'

/** Every blog category of the signed-in user's tenant, sorted by name — the records the tree and the picker read. */
export const useBlogCategoryList = (): UseListResult<BlogCategoryRecord> =>
  useList<BlogCategoryRecord>({ ...blogCategoryQueries.allConfig, limit: 0, sort: { name: 1 } })
